(function () {

  $('[data-solution-target]').click((each) => {
    var selectedTab = each.currentTarget
    var solutionId = selectedTab.dataset.solutionTarget
    if (solutionId) {
      onSolutionTabClick(solutionId)
    }

    $('[data-solution-target]').each((i, tab) => {
      // console.log('match', each.dataset.solutionTarget, solutionId)
      if (tab.dataset.solutionTarget === solutionId) {
        selectedTab.classList.add('selected')

      } else {
        tab.classList.remove('selected')
      }
    })


    selectedTab.parentElement.children
  })

  function onSolutionTabClick(solutionId) {
    $('[data-solution]').each((i, each) => {
      if (each.dataset.solution === solutionId) {
        each.classList.add('active')
      } else {
        each.classList.remove('active')
      }
    })
  }

}());